import {Box, Grid} from '@material-ui/core';
import {PSingleLine} from 'components/TypographyShortcuts';
import {React} from 'globalthis/implementation';
import {
    AmexIcon,
    CheckPaymentIcon,
    CreditCardIcon,
    DinersClubIcon,
    DiscoverIcon,
    GiftCardIcon,
    GravityIcon,
    JCBIcon,
    MastercardVertIcon,
    UnionPayIcon,
    VisaIcon,
} from './paymentIcons';

const cardTypeDict = {
    AX: {
        name: 'American Express',
        icon: AmexIcon,
    },
    CU: {
        name: 'UnionPay',
        graityName: 'China UnionPay',
        icon: UnionPayIcon,
    },
    DC: {
        name: 'Discover',
        icon: DiscoverIcon,
    },
    DN: {
        name: 'Diners Club',
        gravityName: 'Diners',
        icon: DinersClubIcon,
    },
    GC: {
        name: 'Gift Card',
        icon: GiftCardIcon,
    },
    JC: {
        name: 'JCB',
        icon: JCBIcon,
    },
    MC: {
        name: 'Mastercard',
        icon: MastercardVertIcon,
    },
    VS: {
        name: 'Visa',
        icon: VisaIcon,
    },
    CP: {
        name: 'Gravity Test Card',
        gravityName: 'Gravity Payments Test Card',
        icon: GravityIcon,
    },
    XX: {
        name: 'Other',
        icon: CreditCardIcon,
    },
    CK: {
        name: 'Check Guarantee or ACH Funds Transfer',
        icon: CheckPaymentIcon,
    },
};

const CardLogoAndName = ({type}) => {
    let Icon = null;
    let displayName = '';
    if (
        [
            'AX',
            'CU',
            'DC',
            'DN',
            'GC',
            'JC',
            'MC',
            'VS',
            'CP',
            'XX',
            'CK',
        ].includes(type)
    ) {
        Icon = cardTypeDict[type].icon;
        displayName = cardTypeDict[type].name;
    } else {
        Icon = CreditCardIcon;
        displayName = 'Other / Unknown';
    }

    return (
        <Box>
            <Grid container alignItems='flex-start' justifyContent='flex-start'>
                <Grid item>
                    <Icon width='40' height='30' />
                </Grid>
                <Grid item>
                    <PSingleLine>{displayName}</PSingleLine>
                </Grid>
            </Grid>
        </Box>
    );
};

const InlineCardInfo = ({paymentToken}) => {
    // our saved token has cc_expiration_str, tokens fresh from gravity modal have same-format accountExpiryDate
    const expDate =
        paymentToken?.cc_expiration_str ||
        paymentToken?.accountExpiryDate ||
        'xxxx';
    return (
        <Grid container spacing={2}>
            <Grid item>
                <CardLogoAndName type={paymentToken?.accountCardType} />
            </Grid>
            <Grid item>
                <PSingleLine>{paymentToken?.maskedAccount}</PSingleLine>
            </Grid>
            <Grid item>
                <PSingleLine>
                    Exp: {expDate?.substr(0, 2)}/{expDate.substr(2, 2)}
                </PSingleLine>
            </Grid>
        </Grid>
    );
};

export default CardLogoAndName;
export {cardTypeDict, InlineCardInfo};
